// extracted by mini-css-extract-plugin
export var label = "_di-5";
export var slideContainer = "_di-0";
export var slider = "_di-1";
export var sliderLg = "_di-4";
export var sliderMd = "_di-3";
export var sliderSm = "_di-2";